module.exports = __webpack_public_path__ + "static/media/tabs-battles-countdown-regular.d3524c93.png";